<template lang="pug">
.card-box
  div
    h3.text-dark.site-title
      | {{label}}

    template(v-if="show")
      .m-t-30 このまましばらくお待ちください。通常、開始から1分ほどでレポートが表示されます。
      .m-t-20
        ProgressBar(v-bind:value="progress" v-bind:min="0" v-bind:max="1.0")
      //- .m-t-20
      //-   DidYouKnow
</template>

<script>
import ProgressBar from '@/components/common/ProgressBar'
import DidYouKnow from "@/components/DidYouKnow"

export default {
  components: {
    ProgressBar,
    DidYouKnow,
  },
  data() {
    return {
      show: false,
    }
  },
  props: {
    label: String,
    progress: Number,
    status: String,
  },
  conmputed: {
    done() {
      return this.status == 'done';
    },
    waiting() {
      return this.status == 'waiting';
    },
    processing() {
      return !this.done && !this.waiting;
    },
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 1 * 1000)
  }
}
</script>